import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { BaseHttpService } from './base-http.service';

export interface AutoLogoutSetting {
  enabled: boolean;
}

export interface AutoLogoutUpdateResponse {
  success: boolean;
  message: string;
  enabled: boolean;
}

/**
 * Rendszerbeállítások kezelése
 * Jelenleg az automatikus kijelentkezés beállításait kezeli
 */
@Injectable({
  providedIn: 'root'
})
export class SystemSettingsService extends BaseHttpService {
  private autoLogoutEnabledSubject = new BehaviorSubject<boolean>(true);
  public autoLogoutEnabled$ = this.autoLogoutEnabledSubject.asObservable();

  /**
   * Automatikus kijelentkezés beállítás lekérése
   */
  getAutoLogoutSetting(): Observable<AutoLogoutSetting> {
    return this.get<AutoLogoutSetting>('/settings/auto-logout').pipe(
      tap(response => {
        this.autoLogoutEnabledSubject.next(response.enabled);
      })
    );
  }

  /**
   * Automatikus kijelentkezés beállítás frissítése
   */
  updateAutoLogoutSetting(enabled: boolean): Observable<AutoLogoutUpdateResponse> {
    return this.put<AutoLogoutUpdateResponse>('/settings/auto-logout', { enabled }).pipe(
      tap(response => {
        if (response.success) {
          this.autoLogoutEnabledSubject.next(response.enabled);
        }
      })
    );
  }

  /**
   * Aktuális automatikus kijelentkezés állapot lekérése (szinkron)
   */
  isAutoLogoutEnabled(): boolean {
    return this.autoLogoutEnabledSubject.value;
  }
}
